import CheckboxConfig from './CheckboxConfig.vue'
import SelectConfig from './SelectConfig.vue'
import PlaceholderConfig from './PlaceholderConfig.vue'
import EmailConfig from './EmailConfig.vue'
import KeywordConfig from './KeywordConfig.vue'
import TextConfig from './TextConfig.vue'
import DateConfig from './DateConfig.vue'
import FolioConfig from './FolioConfig.vue'
import UserListConfig from './UserListConfig.vue'
import CommandsConfig from './CommandsConfig.vue'
import FacilityConfig from './FacilityConfig.vue'
import TechniciansConfig from './TechniciansConfig.vue'
import FileConfig from './FileConfig.vue'
import TimeConfig from './TimeConfig.vue'

export default {
  checkbox: CheckboxConfig,
  select: SelectConfig,
  placeholder: PlaceholderConfig,
  mail: EmailConfig,
  keyword: KeywordConfig,
  text: TextConfig,
  text_answer: TextConfig,
  date: DateConfig,
  folio: FolioConfig,
  userList: UserListConfig,
  commands: CommandsConfig,
  facilities: FacilityConfig,
  technicians: TechniciansConfig,
  files_section: FileConfig,
  time: TimeConfig,
}